import { render, staticRenderFns } from "./decorate.vue?vue&type=template&id=1c5ff689&scoped=true&"
import script from "./decorate.vue?vue&type=script&lang=js&"
export * from "./decorate.vue?vue&type=script&lang=js&"
import style0 from "./decorate.vue?vue&type=style&index=0&id=1c5ff689&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ff689",
  null
  
)

export default component.exports